import { Outlet } from "react-router-dom";
import { useState } from "react";

import HomeHeader from "../components/Home/HomeHeader/HomeHeader";
import HomeNavbar from "../components/Home/HomeNavbar/HomeNavbar";
import Footer from "../components/Footer/Footer_static";

export default function MainLayout() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <div className="app">

            <HomeHeader
                onMobileMenuClick={() => setMobileMenuOpen(true)}
            />

            <HomeNavbar
                mobileMenuOpen={mobileMenuOpen}
                onCloseMobileMenu={() => setMobileMenuOpen(false)}
            />

            <main className="app-content">
                <Outlet />
            </main>

            <Footer />

        </div>
    );
}